import clsx from 'clsx'

import mainStyles from 'assets/css/main.module.scss'
import Slider from 'components/slider/Slider'
import { AnalyticsActionType } from 'types/analytics.type'
import { CommunityTag } from 'types/community-tags'
import { ANALYTICS_EVENTS, trackAnalytics } from 'utils/analytics'

import styles from './CommunityTagsCarousel.module.scss'

const CommunityTagsCarousel = ({ items }: { items: CommunityTag[] }) => {
  const carouselItems = items?.map(tag => (
    <CommunityTagItem key={tag?.id} title={tag?.name} description={tag?.description} imageSrc={tag?.icon} />
  ))

  return (
    <div
      className={clsx(
        'flex justify-center items-center',
        'tour-communityofpractitioners-findthepractitioner',
        styles.communityTagsCarousel,
      )}
    >
      <Slider
        items={carouselItems}
        slidesPerView={3.5}
        id="communityTags"
        className="w-full !px-[100px]"
        paginationUpdateAction={(page: number) =>
          trackAnalytics({
            type: AnalyticsActionType.action,
            payload: {
              action: ANALYTICS_EVENTS.PRACTITIONERS_CT_SLIDER_DOTS_CLICKED,
              params: [
                {
                  key: 'page',
                  value: page.toString(),
                },
              ],
            },
          })
        }
        navigationNextAction={(page: number) =>
          trackAnalytics({
            type: AnalyticsActionType.action,
            payload: {
              action: ANALYTICS_EVENTS.PRACTITIONERS_CT_SLIDE_RIGHT_ARROW_CLICKED,
              params: [{ key: 'page', value: page.toString() }],
            },
          })
        }
        navigationPrevAction={(page: number) =>
          trackAnalytics({
            type: AnalyticsActionType.action,
            payload: {
              action: ANALYTICS_EVENTS.PRACTITIONERS_CT_SLIDE_LEFT_ARROW_CLICKED,
              params: [{ key: 'page', value: page.toString() }],
            },
          })
        }
      />
    </div>
  )
}

interface CommunityTagProps {
  imageSrc?: any
  title?: string
  description?: string
  className?: string
}

const CommunityTagItem = ({ imageSrc, title, description, className }: CommunityTagProps) => {
  return (
    <div className={clsx('flex flex-col', className)}>
      <div className="relative w-fit">
        <img className="max-w-[100px] z-2 relative" src={imageSrc} alt="icon" />
        <svg
          className="z-1 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          xmlns="http://www.w3.org/2000/svg"
          width="58"
          height="58"
          viewBox="0 0 58 58"
          fill="none"
        >
          <circle cx="29" cy="29" r="29" fill="#EBFF00" />
        </svg>
      </div>
      <div>
        <p className={clsx(mainStyles.cokeRedH2, styles.title)}>{title}</p>
      </div>
      <div>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  )
}

export default CommunityTagsCarousel
